import { render, staticRenderFns } from "./feature-detail.vue?vue&type=template&id=3c5d5a5a&"
import script from "./feature-detail.vue?vue&type=script&lang=js&"
export * from "./feature-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports